import { EDUCATION } from "../Constants/constants";
import { motion } from "framer-motion";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { useVelocitySkew } from "../hooks/useVelocitySkew";
import SectionTitle from "./SectionTitle";

// Alternation starts on the right so the rhythm continues from the last
// Experience card instead of mirroring it.
function EducationCard({ education, index }) {
  const alignRight = index % 2 === 0;
  const skewY = useVelocitySkew();
  const { ref, opacity, offset } = useScrollReveal({
    delay: 0.1,
    distance: 50,
    axis: "x",
    fromRight: alignRight,
  });

  return (
    <motion.div ref={ref} style={{ opacity, x: offset, skewY }}>
      <div
        className={`glass-card mb-10 max-w-2xl rounded-xl p-6 transition-colors duration-300 ${
          alignRight ? "lg:ml-auto" : "lg:mr-auto"
        }`}
      >
        <p className="text-biolum-green mb-1 font-mono text-sm tracking-widest">
          {education.year}
        </p>
        <h6 className="text-slate-100 mb-2 text-xl font-bold">
          {education.institution} -{" "}
          <span className="text-xl text-biolum-blue">{education.degree}</span>
        </h6>
        <p
          className="text-slate-300 text-base text-pretty"
          style={{ whiteSpace: "pre-line" }}
        >
          {education.description}
        </p>
      </div>
    </motion.div>
  );
}

export default function Education() {
  return (
    <section id="education">
      <div className="mx-auto max-w-5xl py-16">
        <SectionTitle>Education</SectionTitle>
        {EDUCATION.map((education, index) => (
          <EducationCard key={education.degree} education={education} index={index} />
        ))}
      </div>
    </section>
  );
}
